import { useState, useContext, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { C } from '../constants';
import { getRozetkaUrl } from '../utils';
import { ProductNavContext } from './ProductNavContext';

const truncStyle = (style) => ({
  color: style.color || C.text1, fontWeight: 600,
  overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
  display: "block", ...style,
});

export default function ProdLink({ name, article, productId, style = {}, marketplace, noMenu = false }) {
  const nav = useContext(ProductNavContext);
  const [menu, setMenu] = useState(null); // {x, y}
  const ref = useRef(null);

  const isEp = marketplace === 'epicentr';

  // noMenu (e.g. Products tab) or no context → keep simple direct behavior
  if (noMenu || !nav) {
    if (isEp) {
      return <span title={name} style={truncStyle(style)}>{name}</span>;
    }
    return (
      <a href={getRozetkaUrl(productId)} target="_blank" rel="noreferrer" title={name}
        style={{ ...truncStyle(style), textDecoration: "none" }}
        onMouseEnter={e => { e.currentTarget.style.color = C.blue; e.currentTarget.style.textDecoration = "underline"; }}
        onMouseLeave={e => { e.currentTarget.style.color = style.color || C.text1; e.currentTarget.style.textDecoration = "none"; }}>
        {name}
      </a>
    );
  }

  const openMenu = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const r = e.currentTarget.getBoundingClientRect();
    setMenu({ x: r.left, y: r.bottom + 4 });
  };

  return (
    <>
      <span
        ref={ref}
        title={name}
        onClick={openMenu}
        style={{ ...truncStyle(style), cursor: "pointer" }}
        onMouseEnter={e => { e.currentTarget.style.color = C.blue; }}
        onMouseLeave={e => { e.currentTarget.style.color = style.color || C.text1; }}>
        {name}
      </span>
      {menu && <ProdMenu pos={menu} onClose={() => setMenu(null)} isEp={isEp} productId={productId}
        onProducts={() => { nav.openProductInProducts(productId); setMenu(null); }} />}
    </>
  );
}

function ProdMenu({ pos, onClose, isEp, productId, onProducts }) {
  useEffect(() => {
    const onDoc = (e) => { if (!e.target.closest?.("[data-prodmenu]")) onClose(); };
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("mousedown", onDoc);
    document.addEventListener("keydown", onKey);
    return () => { document.removeEventListener("mousedown", onDoc); document.removeEventListener("keydown", onKey); };
  }, [onClose]);

  const item = {
    display: "block", width: "100%", textAlign: "left",
    padding: "9px 14px", background: "none", border: "none", cursor: "pointer",
    fontSize: 13, color: C.text1, whiteSpace: "nowrap",
  };

  // keep within viewport horizontally
  const left = Math.min(pos.x, window.innerWidth - 230);

  return createPortal(
    <div data-prodmenu style={{
      position: "fixed", top: pos.y, left, zIndex: 3000,
      background: C.bg1, border: `1px solid ${C.border}`, borderRadius: 10,
      boxShadow: "0 8px 30px rgba(0,0,0,.5)", overflow: "hidden", minWidth: 210,
    }}>
      {!isEp && (
        <button style={item}
          onMouseEnter={e => e.currentTarget.style.background = C.bg2}
          onMouseLeave={e => e.currentTarget.style.background = "none"}
          onClick={() => { window.open(getRozetkaUrl(productId), "_blank", "noopener"); onClose(); }}>
          ↗ Відкрити на Rozetka
        </button>
      )}
      <button style={item}
        onMouseEnter={e => e.currentTarget.style.background = C.bg2}
        onMouseLeave={e => e.currentTarget.style.background = "none"}
        onClick={onProducts}>
        📦 Відкрити в Товарах
      </button>
    </div>,
    document.body
  );
}
